import type { MessagingChannelsCopy } from './types';

export const AR: MessagingChannelsCopy = {
  title: 'المراسلة',
  description:
    'تحدّث مع IMAI من تطبيقات الدردشة التي تستخدمها بالفعل. اربط حسابك مرة واحدة ثم راسل IMAI من هناك.',
  privacy:
    'الرسائل الواردة من حساباتك المرتبطة تُنفَّذ باسمك في مساحة العمل هذه وتستهلك أرصدتك.',
  loading: 'جارٍ تحميل قنوات المراسلة',
  unavailable: 'غير متاح بعد',
  unavailableNote: 'لم يتم إعداد {channel} لـ IMAI بعد.',
  connectedBadge: 'مرتبط',
  cancel: 'إلغاء',

  phoneTitle: 'رقم الهاتف',
  phoneNote: 'اربط WhatsApp أو iMessage باستخدام رقم هاتفك.',
  phoneUnavailableNote: 'مراسلة IMAI عبر الرسائل النصية غير مُعدّة بعد.',
  addNumber: 'إضافة رقم',
  countryLabel: 'رمز الدولة',
  countrySearch: 'ابحث عن بلد أو رمز…',
  countryEmpty: 'لم يتم العثور على بلدان.',
  numberLabel: 'رقم الهاتف',
  numberPlaceholder: 'رقم الهاتف',
  numberHint: 'دولتك غير موجودة؟ اكتب الرقم كاملًا بدءًا بـ +.',
  continueActivation: 'متابعة',
  editNumber: 'تغيير الرقم',
  activateQr: 'امسح وأرسل للاتصال.',
  activateTitle: 'أرسل رسالة واحدة عبر WhatsApp',
  activateHint: 'اضغط الزر وأرسل الرسالة المكتوبة لك مسبقًا.',
  activateSentFrom: 'أرسلها من {number}.',
  activateButton: 'فتح {channel}',
  activateManual: 'أو أرسل {message} إلى {number} عبر WhatsApp.',
  activateWaiting: 'بانتظار رسالتك. تنتهي الصلاحية خلال {time}.',
  startAgain: 'البدء من جديد',
  verifiedBadge: 'تم التحقق',
  verifiedOn: 'تم التحقق في {date}',
  change: 'تغيير',
  changeAria: 'تغيير رقم الهاتف {number}',
  remove: 'إزالة',
  removeAria: 'إزالة رقم الهاتف {number}',
  messageImai: 'راسل IMAI',
  messageImaiAria: 'راسل IMAI عبر {channel}',
  removeTitle: 'إزالة {number}؟',
  removeDescription:
    'سيتوقف IMAI عن الرد على هذا الرقم في iMessage وWhatsApp. يمكنك إضافته مجددًا في أي وقت.',
  removeError: 'تعذّرت إزالة الرقم. حاول مرة أخرى.',

  errorInvalidNumber: 'أدخل رقم هاتف صالحًا مع رمز المنطقة.',
  errorNumberTaken: 'هذا الرقم مستخدم بالفعل في حساب IMAI آخر.',
  errorRateLimited: 'محاولات كثيرة جدًا. انتظر قليلًا ثم حاول مرة أخرى.',
  errorChannelUnavailable: 'هذا الخيار غير متاح الآن. اختر الخيار الآخر.',
  errorSendFailed: 'تعذّر بدء التحقق. حاول مرة أخرى.',
  errorActivationExpired: 'انتهت صلاحية هذا التفعيل. ابدأ من جديد.',

  noteSlack: 'راسل IMAI من مساحة عملك على Slack.',
  noteTeams: 'راسل IMAI من Microsoft Teams.',
  noteTelegram: 'دردش مع بوت IMAI على Telegram.',
  connect: 'ربط',
  connectAria: 'ربط {channel}',
  connectError: 'تعذّر بدء ربط {channel}. حاول مرة أخرى.',
  connectedOn: 'تم الربط في {date}',
  accountFallback: 'حسابك على {channel}',
  installSlack: 'أضف IMAI إلى مساحة عملك',
  installTeams: 'أضف IMAI إلى Teams',
  openTelegram: 'فتح في Telegram',
  disconnect: 'فصل',
  disconnectAria: 'فصل {account} عن {channel}',
  disconnectError: 'تعذّر فصل {channel}. حاول مرة أخرى.',
  disconnectTitle: 'فصل {channel}؟',
  disconnectDescription:
    'لن تصل الرسائل من {account} إلى IMAI بعد الآن. يمكنك ربطه مجددًا في أي وقت.',

  toastConnected: 'تم ربط {channel}',
  toastConnectedGeneric: 'تم ربط الحساب',
  toastErrorExpired: 'استغرق تسجيل الدخول وقتًا طويلًا. حاول الربط مرة أخرى.',
  toastErrorInvalidState: 'رابط تسجيل الدخول لم يعد صالحًا. حاول مرة أخرى.',
  toastErrorAccountTaken: 'هذا الحساب مرتبط بالفعل بمستخدم آخر في IMAI.',
  toastErrorNotMember: 'لم تعد عضوًا في مساحة العمل هذه.',
  toastErrorProvider: 'لم يكتمل تسجيل الدخول. حاول الربط مرة أخرى.',
  toastErrorGeneric: 'تعذّر ربط الحساب. حاول مرة أخرى.',
};
